import { type CaseReducer, type PayloadAction } from '@reduxjs/toolkit';

import { initialFilters } from '../initialState';
import { type FilterGroupState } from '../types';

const restoreFilterGroupCase: CaseReducer<
  FilterGroupState,
  PayloadAction<keyof FilterGroupState>
> = (state, action) => {
  const { payload: key } = action;

  return {
    ...state,
    [key]: initialFilters[key],
  };
};

export { restoreFilterGroupCase };
